<template>
  <div id="app" class="cs-wrapper">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import { AppDeviceEnquire } from "@/core/mixin";

export default {
  name: "App",
  mixins: [AppDeviceEnquire],
  provide(){
    return {
      reload: this.reload
    }
  },
  created(){

  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(() =>{
        this.isRouterAlive = true;
      });
    }
  },
};
</script>

<style lang="scss">
@import "element-ui/lib/theme-chalk/index.css";
@import "./style/displayEx.css";
@import "./style/v-tooltip.scss";
@import "./style/speedup.css";
@import "bootstrap/dist/css/bootstrap.min.css";
@import "font-awesome/css/font-awesome.min.css";
@import "./assets/iconfont.css";
@import "./style/common.scss";
@import "./style/navigator.scss";

.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.3s;
}
.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}
.cs-header {
}
</style>




// WEBPACK FOOTER //
// src/App.vue